import {
  VIDEO_QUALITY,
  VIDEO_SETTINGS,
  VIDEO_SUBTITLES,
  VIDEO_SPEED,
  VIDEO_AUDIO
} from 'types/unacademyIcons/player.types';

export const VIDEO_SETTINGS_OPTIONS = {
  [VIDEO_SETTINGS.VIDEO_SPEED]: {
    [VIDEO_SPEED.S_075x]: '0.75x',
    [VIDEO_SPEED.NORMAL]: 'Normal',
    [VIDEO_SPEED.F_125x]: '1.25x',
    [VIDEO_SPEED.F_150x]: '1.5x',
    [VIDEO_SPEED.F_175x]: '1.75x',
    [VIDEO_SPEED.F_200x]: '2x'
  },
  [VIDEO_SETTINGS.VIDEO_QUALITY]: {
    [VIDEO_QUALITY.AUTO]: 'Auto',
    [VIDEO_QUALITY.LOW]: 'Low',
    [VIDEO_QUALITY.MEDIUM]: 'Medium',
    [VIDEO_QUALITY.HIGH]: 'High'
  },
  [VIDEO_SETTINGS.SUBTITLES]: {
    [VIDEO_SUBTITLES.OFF]: { Off: 'Off' }
  },
  [VIDEO_SETTINGS.VIDEO_AUDIO]: {
    [VIDEO_AUDIO.ENGLISH]: { English: 'English' }
  }
};

export const PLAYER_STORAGE_KEYS = {
  LESSON_VOLUME: 'lesson_volume',
  LESSON_SUBTITLE: 'lesson_subtitle',
  LESSON_SPEED: 'lesson_speed',
  LESSON_QUALITY: 'lesson_quality',
  LESSON_LANGUAGE: 'lesson_language'
};
